/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Calendar_Quota_Week_Current_OtherInputs */

const fr_calendar_quota_week_current_other = /** @type {(inputs: Calendar_Quota_Week_Current_OtherInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} séances restantes cette semaine`)
};

/**

* @param {Calendar_Quota_Week_Current_OtherInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calendar_quota_week_current_other = /** @type {((inputs: Calendar_Quota_Week_Current_OtherInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Quota_Week_Current_OtherInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calendar_quota_week_current_other(inputs)
});